import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from './config/router';
import './styles/global.css';

// Importando o ReactVLibras Plugin
import ReactVLibras from 'react-vlibras-plugin';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    {/* Seu RouterProvider */}
    <RouterProvider router={router} />

    {/* Adicionando o componente VLibras */}
    <ReactVLibras
      position="right" // Posição do widget
      avatar="guga" // Avatar do widget
      opacity={0.8} // Opacidade do widget
    />
  </React.StrictMode>,
);
